import { useCallback, useEffect, useState } from "react";

const LOCAL_STORAGE_KEY = "recentlySearchedPatients";
const MAX_RECENT_PATIENTS = 5;

const getRecentPatientsFromLocalStroage = () => {
  const locallyStoredPatientsString = localStorage.getItem(LOCAL_STORAGE_KEY);
  return locallyStoredPatientsString
    ? JSON.parse(locallyStoredPatientsString)
    : [];
};

const updateRecentPatientsInLocalStorage = (recentPatientIds: number[]) => {
  if (recentPatientIds.length !== 0) {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(recentPatientIds));
  }
};

const useRecentlySearchedPatients = () => {
  const [recentPatientIds, setRecentPatientIds] = useState<number[]>(
    getRecentPatientsFromLocalStroage
  );

  // Stable, and a no-op when the patient is already the most recent. PatientSearch calls
  // this from an effect that re-runs while a patient stays selected, so a fresh array (or
  // a fresh callback) here re-rendered it in an endless loop (DEV-3008).
  const addPatientToRecent = useCallback((patientID: number) => {
    setRecentPatientIds((prevState: number[]) => {
      if (prevState[prevState.length - 1] === patientID) {
        return prevState;
      }
      return [...prevState.filter((id) => id !== patientID), patientID].slice(
        -MAX_RECENT_PATIENTS
      );
    });
  }, []);

  useEffect(() => {
    updateRecentPatientsInLocalStorage(recentPatientIds);
  }, [recentPatientIds]);

  return {
    recentPatientIds,
    addPatientToRecent
  };
};

export default useRecentlySearchedPatients;
